import React, { useEffect, useState } from "react";
import { Card, Spin, Row, Col, Image, Empty, Modal, Button, Input, notification } from "antd";
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { useImagenesPokemon } from "../queries/useImagenesPokemon";
import { useEditarImagen } from "../queries/useEditarImagen";

export const ImagenesPokemon = ({ id }) => {
  const editarImagenMutation = useEditarImagen();
  const [modalOpen, setModalOpen] = useState(false);
  const [uploadType, setUploadType] = useState(null);
  const [formValues, setFormValues] = useState({ url: '', nombre: '' });

  const { data, isLoading, error, refetch } = useImagenesPokemon(id);

  useEffect(() => {
    if (id) refetch();
  }, [id]);

  // Manejo de datos
  let imagen = {};
  if (Array.isArray(data)) {
    imagen = data[0] || {};
  } else if (data && (data.imagCardUrl || data.imagDexUrl || data.imagUrl)) {
    imagen = data;
  }

  const recuadros = [
    {
      key: 'dex',
      label: 'Imagen Normal',
      url: imagen.imagDexUrl,
      nombre: imagen.imagDexNombre,
    },
    {
      key: 'card',
      label: 'Imagen Carta',
      url: imagen.imagCardUrl,
      nombre: imagen.imagCardNombre,
    },
    {
      key: 'normal',
      label: 'Imagen Sprite',
      url: imagen.imagUrl,
      nombre: imagen.imagNombre,
    },
  ];

  const handleOpenModal = (type) => {
    setUploadType(type);
    setModalOpen(true);
    const rec = recuadros.find(r => r.key === type);
    setFormValues({
      url: rec?.url || '',
      nombre: rec?.nombre || '',
    });
  };

  const getModalTitle = () => {
    const typeLabels = {
      'dex': 'Imagen Normal',
      'card': 'Imagen Carta', 
      'normal': 'Imagen Sprite'
    };
    const label = typeLabels[uploadType] || 'Imagen';
    const action = formValues.url ? 'Editar' : 'Subir';
    return `${action} ${label}`;
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setUploadType(null);
    setFormValues({ url: '', nombre: '' });
  };

  const handleSaveImage = async (url, nombre) => {
    let body = { id };
    if (uploadType === 'dex') {
      body.imagDexUrl = url;
      body.imagDexNombre = nombre || null;
    } else if (uploadType === 'card') {
      body.imagCardUrl = url;
      body.imagCardNombre = nombre || null;
    } else {
      body.imagUrl = url;
      body.imagNombre = nombre || null;
    }
    try {
      await editarImagenMutation.mutateAsync(body);
      refetch();
      notification["success"]({ message: "Imagen Editada" });
    } catch (e) {
      notification["error"]({ message: "Error al editar imagen" });
    }
    handleCloseModal();
  };

  if (!id) return <Card title="Imágenes del Pokémon" style={{ borderRadius: '12px', border: '1px solid #f0f0f0', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)' }}>Selecciona un Pokémon</Card>;
  if (isLoading) return <Spin fullscreen={true} tip="Cargando imágenes..." />;
  if (error) return <Card title="Imágenes del Pokémon" style={{ borderRadius: '12px', border: '1px solid #f0f0f0', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)' }}>Error al cargar imágenes</Card>;

  return (
    <Card title="Imágenes del Pokémon" style={{ borderRadius: '12px', border: '1px solid #f0f0f0', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)' }}>
      <Row gutter={[16, 16]} style={{ display: 'flex', alignItems: 'center' }}>
        {recuadros.map((rec, idx) => (
          <Col span={8} key={rec.key} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {rec.url ? (
              <div style={{ position: 'relative', width: 200, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Image src={rec.url} alt={rec.nombre || rec.label} width={200} style={{ cursor: 'pointer' }} />
                <div style={{ textAlign: 'center', marginTop: 8 }}>{rec.nombre || rec.label}</div>
                
                {/* Botón de editar pequeño en la esquina */}
                <Button 
                  size="small" 
                  style={{ 
                    position: 'absolute', 
                    top: 8, 
                    right: 8, 
                    background: 'rgba(0,0,0,0.6)', 
                    color: 'white', 
                    border: 'none', 
                    borderRadius: 4, 
                    boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
                    zIndex: 1000,
                    width: 32,
                    height: 32,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 0
                  }} 
                  onClick={() => handleOpenModal(rec.key)}
                  icon={<EditOutlined style={{ color: 'white', fontSize: 14 }} />}
                  title="Editar imagen"
                />
                
                {/* Botón de editar más visible */}
                <Button 
                  type="primary"
                  size="small"
                  icon={<EditOutlined />}
                  style={{ 
                    marginTop: 8,
                    borderRadius: 6
                  }}
                  onClick={() => handleOpenModal(rec.key)}
                >
                  Editar
                </Button>
              </div>
            ) : (
              <div
                style={{
                  width: 200,
                  height: 200,
                  border: '2px dashed #d9d9d9',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  cursor: 'pointer',
                  background: '#fafafa',
                }}
                onClick={() => handleOpenModal(rec.key)}
              >
                <PlusOutlined style={{ fontSize: 32, color: '#bfbfbf' }} />
                <div style={{ marginTop: 8, color: '#bfbfbf' }}>Subir {rec.label}</div>
              </div>
            )}
          </Col>
        ))}
      </Row>
      <Modal
        open={modalOpen}
        title={getModalTitle()}
        onCancel={() => {
          handleCloseModal();
          setFormValues({ url: '', nombre: '' });
        }}
        footer={null}
      >
        <form
          onSubmit={e => {
            e.preventDefault();
            const url = e.target.elements.url.value;
            const nombre = e.target.elements.nombre.value;
            handleSaveImage(url, nombre);
            setFormValues({ url: '', nombre: '' });
          }}
        >
          <label htmlFor="url">URL de la imagen:</label>
          <Input
            id="url"
            name="url"
            type="url"
            placeholder="https://..."
            style={{ width: '100%', margin: '12px 0', padding: 8 }}
            required
            value={formValues.url}
            onChange={e => setFormValues(v => ({ ...v, url: e.target.value }))}
          />
          <label htmlFor="nombre">Nombre de la imagen:</label>
          <Input
            id="nombre"
            name="nombre"
            type="text"
            placeholder="Nombre descriptivo"
            style={{ width: '100%', margin: '12px 0', padding: 8 }}
            required
            value={formValues.nombre}
            onChange={e => setFormValues(v => ({ ...v, nombre: e.target.value }))}
          />
          <Button type="primary" htmlType="submit" block>
            {formValues.url ? 'Actualizar imagen' : 'Guardar imagen'}
          </Button>
        </form>
      </Modal>
    </Card>
  );
};
